import React from 'react';
import { CacheProvider, Global } from '@emotion/react';
import { CacheProvider as LegacyCacheProvider } from '@emotion/core';
import { globalStyles } from '@domain-group/fe-brary';
import createCache from '@emotion/cache';

export const emotionCache = createCache({ key: 'css' });

// eslint-disable-next-line react/prop-types
const EmotionWrapper = ({ children }) => (
  <CacheProvider value={emotionCache}>
    <LegacyCacheProvider value={emotionCache}>
      <Global styles={globalStyles} />
      {children}
    </LegacyCacheProvider>
  </CacheProvider>
);

export default EmotionWrapper;
